import currencyMap from "currency-symbol-map/map";

const formatCurrency = (currency) => {
  return currencyMap[currency] || currency;
};

export { formatCurrency };
